import { render, staticRenderFns } from "./mt5ArticleContent.vue?vue&type=template&id=62522da2&scoped=true&"
import script from "./mt5ArticleContent.vue?vue&type=script&lang=js&"
export * from "./mt5ArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./mt5ArticleContent.vue?vue&type=style&index=0&id=62522da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62522da2",
  null
  
)

component.options.__file = "mt5ArticleContent.vue"
export default component.exports